module.exports = __webpack_public_path__ + "static/media/november_11.214b5228.png";